module.exports = __webpack_public_path__ + "img/shipping_type_5.df6a17c.png";